export default "__VITE_ASSET__tpAq9SzC__"